import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";

function Hero() {
  const [hovered, setHovered] = useState(null);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  return (
    <div style={styles.hero}>
      <h1 style={styles.title}>
        Welcome To Carolina <br /> Sports Club
      </h1>
      <p style={styles.subtitle}>Learn. Play. Have Fun!</p>

      {/* CTA Buttons */}
      <div style={styles.buttons}>
        {/* BOOK BUTTON */}
        <button
          style={{
            ...styles.primary,
            ...(hovered === "book" ? styles.primaryHover : {}),
          }}
          onMouseEnter={() => setHovered("book")}
          onMouseLeave={() => setHovered(null)}
          onClick={() => navigate("/search")}
        >
          Book a Court
        </button>

        {/* SHOW ONLY IF NOT LOGGED IN */}
        {!isAuthenticated && (
          <Link
            to="/signup"
            style={{
              ...styles.primary,
              ...(hovered === "join" ? styles.primaryHover : {}),
            }}
            onMouseEnter={() => setHovered("join")}
            onMouseLeave={() => setHovered(null)}
          >
            Join the Club
          </Link>
        )}
      </div>
    </div>
  );
}

const styles = {
  hero: {
    textAlign: "center",
    marginTop: "10px",
    color: "#000",
  },

  title: {
    fontSize: "64px",
    fontWeight: "800",
    lineHeight: "1.2",
  },

  subtitle: {
    fontSize: "22px",
    marginTop: "10px",
    color: "#222",
  },

  buttons: {
    marginTop: "25px",
    display: "flex",
    justifyContent: "center",
    gap: "15px",
  },

  primary: {
    padding: "12px 28px",
    borderRadius: "999px",
    border: "none",
    fontWeight: "bold",
    fontSize: "16px",
    background: "linear-gradient(90deg, #00ff88, #00d4ff)",
    color: "#0a1a0a",
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-block",
    transition: "all 0.3s ease",
  },

  primaryHover: {
    transform: "translateY(-3px) scale(1.05)",
    boxShadow: "0 15px 35px rgba(0,255,136,0.45)",
  },
};

export default Hero;